import { SyncTransport } from '@doneline/sync';
import { getAccessToken, getSessionSync } from '../auth/session';

let transport: SyncTransport | null = null;
const userTransports = new Map<string, SyncTransport>();

function makeTransport(expectedUserId?: string): SyncTransport {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;
  if (!baseUrl) {
    throw new Error('Missing VITE_API_BASE_URL. Check apps/web/.env.local or .env');
  }
  return new SyncTransport({
    baseUrl,
    getAccessToken: expectedUserId
      ? async () => {
          const token = await getAccessToken();
          // getAccessToken 内部会 await Supabase。若 await 期间 A→B，不能把刚取得的 B token
          // 用在已经捕获 A outbox/cursor 的旧请求上；必须在 fetch 前按当前 session 再验一次。
          if (getSessionSync()?.userId !== expectedUserId) {
            throw new Error(`sync user changed while acquiring token for ${expectedUserId}`);
          }
          return token;
        }
      : getAccessToken,
  });
}

export function getSyncTransport(expectedUserId?: string | null): SyncTransport {
  if (expectedUserId) {
    let scoped = userTransports.get(expectedUserId);
    if (!scoped) {
      scoped = makeTransport(expectedUserId);
      userTransports.set(expectedUserId, scoped);
    }
    return scoped;
  }
  transport ??= makeTransport();
  return transport;
}

export function hasApiConfig(): boolean {
  return Boolean(import.meta.env.VITE_API_BASE_URL);
}
